// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"api","clipPath":"url(#clip0_543_8057)"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 5L12 2L9 5M19 15L22 12L19 9M9 19L12 22L15 19M5 8.99999L2 12L5 15M11.998 11.998H12.002V12.002H11.998V11.998Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ApiIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'api',
    ref,
    icon: element,
  },
));

ApiIcon.displayName = 'ApiIcon';

export default ApiIcon;
